import React from 'react';
import PropTypes from 'prop-types';

const LoginIcon = props => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      className={props.className || ''}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 8.96456H8.31609L6.58039 10.8147L7.41963 11.5967L10.4142 8.39235L7.41963 5.18799L6.58039 5.97001L8.31609 7.82014H0V8.96456Z" />
      <path d="M13.9999 0H3.7002V4.95914H4.84461V1.14442H12.8555V15.6403H4.84461V11.8256H3.7002V16.7848H13.9999V0Z" />
    </svg>
  );
};

LoginIcon.propTypes = {
  className: PropTypes.string,
};

export default LoginIcon;
